<template>
    <input
            v-model="currentValue"
            @change="valueChanged"
            class="ak-form__control"
    />
</template>

<script>

export default {
    name: 'ak-input',
    data() {
        return {
            currentValue: false
        }
    },
    props: {
        id: {
            type: String
        },
        value: {
            type: String
        },
    },
    methods: {
        valueChanged() {
            this.$emit('change', this.currentValue);
        },
    },
    mounted() {
        this.currentValue = this.value;
    }
}
</script>
